import { observable, action } from "mobx";
import { default as firebase } from "common/Firebase";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { CostPlan } from "./models/CostPlan";
import { CostPlanService } from "modules/costPlan/CostPlanService";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { CostPlanExport } from "modules/costPlan/models/CostPlanExport";
import BaseStore from "../../common/BaseStore";
import { now } from "utils/FirebaseUtils";
import { WBSStore } from "modules/WBS/WBSStore";
import axios from "axios";
class Store extends BaseStore {
  @observable progressStatus: number;
  @observable fileName: string;
  @observable wbsSelected: FirebaseDocument<CostPlan> | false | null = null;
  @observable wbsFileExport: FirebaseDocument<CostPlanExport> | false | null =
    null;
  @observable layerAdd: boolean = false;
  @observable urlDownload: string;
  @observable fileUpload: any = null;
  @observable fileUploadName: any = null;
  @observable fillStructCodeColumn: boolean = false;
  @observable fillAlternativeCodeColumn: boolean = false;
  @observable fillResourceCodeColumn: boolean = false;
  @observable fillResourceQuantityColumn: boolean = false;
  @observable fillResourceCostColumn: boolean = false;
  @observable fillDescriptionColumn: boolean = false;
  @observable fillCoefficientColumn: boolean = false;
  @observable fillServiceQuantityColumn: boolean = false;
  @observable fillCoefficentColumn: boolean = false;
  @observable fillQuantityColumn: boolean = false;
  @observable fillServiceCostColumn: boolean = false;
  @observable fillUnitColumn: boolean = false;
  @observable fillAlternativeColumn: boolean = false;
  @observable fillUnitCostColumn: boolean = false;
  @observable fillTotalColumn: boolean = false;
  @observable buttonNewSheet: boolean = false;
  @observable importCostPlanFileStatus: string = "pending";
  @observable importCostPlanFileProgess: string = "0";
  @observable importCostPlanFileErrorMessage: string = "";
  @observable currentCostPlan: string;

  @observable importLoading: number = -1;
  @observable openGridDialog: boolean = false;
  @observable openBlankWbs: boolean = false;

  lastWbsSelected: FirebaseDocument<CostPlan> | false | null = null;
  budgetColumnFileds: any;
  customColumnFields: any;
  fieldsCustomBudgetKey: any;
  fieldsCustomBudgetValue: any;
  structCodeColumn: any = -1;
  alternativeCodeColumn: any = -1;
  resourceCodeColumn: any = -1;
  resourceQuantityColumn: any = -1;
  resourceCostColumn: any = -1;
  descriptionColumn: any = -1;
  coefficientColumn: any = -1;
  serviceQuantityColumn: any = -1;
  serviceCostColumn: any = -1;
  unitColumn: any = -1;
  alternativeColumn: any = -1;
  unitCostColumn: any = -1;
  totalColumn: any = -1;
  coefficentColumn: any = -1;
  quantityColumn: any = -1;
  @observable arrayObjCustomBudget: any = [];
  arrayObjBudgets: any = [];

  private _customFields: any = {};
  public error = { message: "", detail: "" };
  constructor() {
    super("CostPlanStore");
  }

  resetStore() {
    this.progressStatus = 0;
    this.fileName = "";
    this.wbsSelected = null;
    this.wbsFileExport = null;
    this.layerAdd = false;
    this.urlDownload = "";
    this.fileUpload = null;
    this._customFields = {};
    this.customColumnFields = false;
    this.budgetColumnFileds = false;
    this.structCodeColumn = -1;
    this.alternativeCodeColumn = -1;
    this.resourceCodeColumn = -1;
    this.resourceQuantityColumn = -1;
    this.resourceCostColumn = -1;
    this.descriptionColumn = -1;
    this.coefficientColumn = -1;
    this.serviceQuantityColumn = -1;
    this.serviceCostColumn = -1;
    this.unitColumn = -1;
    this.alternativeColumn = -1;
    this.unitCostColumn = -1;
    this.totalColumn = -1;
    this.quantityColumn = -1;
    this.fillStructCodeColumn = false;
    this.fillAlternativeCodeColumn = false;
    this.fillResourceCodeColumn = false;
    this.fillResourceQuantityColumn = false;
    this.fillResourceCostColumn = false;
    this.fillDescriptionColumn = false;
    this.fillCoefficientColumn = false;
    this.fillServiceQuantityColumn = false;
    this.fillServiceCostColumn = false;
    this.fillUnitColumn = false;
    this.fillAlternativeColumn = false;
    this.fillUnitCostColumn = false;
    this.fillTotalColumn = false;
    this.fillQuantityColumn = false;
    this.importCostPlanFileStatus = "pending";
    this.importCostPlanFileProgess = "0";
    this.importCostPlanFileErrorMessage = "";
    this.importLoading = -1;
    this.openGridDialog = false;
    this.openBlankWbs = false;
  }

  @action
  setOpenBlankWbs(openBlankWbs: boolean) {
    this.openBlankWbs = openBlankWbs;
  }
  getOpenBlankWbs(): boolean {
    return this.openBlankWbs;
  }
  @action
  setOpenGridDialog(openGridDialog: boolean) {
    this.openGridDialog = openGridDialog;
  }
  getOpenGridDialog(): boolean {
    return this.openGridDialog;
  }
  @action
  setImportLoading(importLoading: number) {
    this.importLoading = importLoading;
  }
  getImportLoading(): number {
    return this.importLoading;
  }
  setFields(field, value, nameField) {
    let fields = { name: nameField, column: field };
    let newFields = { ...this.budgetColumnFileds, [field]: fields };
    this.budgetColumnFileds = { ...newFields };
  }

  setFieldsCustomBudgetKey(field, key) {
    let newFields = { ...this.fieldsCustomBudgetKey, [key]: field };
    this.fieldsCustomBudgetKey = { ...newFields };

    if (this.arrayObjCustomBudget.length > 0) {
      const values = { ...this.arrayObjCustomBudget[key] };
      this.arrayObjCustomBudget.splice(key, 1, {
        label: field,
        column: values.column,
      });
    } else {
      this.arrayObjCustomBudget.splice(key, 1, {
        label: field,
        column: undefined,
      });
    }
  }

  setFieldsCustomBudgetValue(field, key) {
    let newFields = { ...this.fieldsCustomBudgetValue, [key]: field };
    this.fieldsCustomBudgetValue = { ...newFields };

    if (this.arrayObjCustomBudget.length > 0) {
      const values = { ...this.arrayObjCustomBudget[key] };
      this.arrayObjCustomBudget.splice(key, 1, {
        label: values.label,
        column: field,
      });
    } else {
      this.arrayObjCustomBudget.splice(key, 1, {
        label: undefined,
        column: field,
      });
    }
  }

  unsetFieldsCustomBudgetKeyAndValue(key) {
    this.arrayObjCustomBudget.splice(key, 1);
    // this.fieldsCustomBudgetValue.delet(key);
  }

  setCustomField(key, field, value) {
    if (!key || !field || value === undefined) {
      return;
    }

    let newCustomFields = { ...this._customFields };
    newCustomFields[key] = {
      field,
      value,
    };

    this._customFields = { ...newCustomFields };
  }

  getRowLaborAndMaterialPrice(WBSRows, id) {
    return CostPlanService.getRowLaborAndMaterialPrice(WBSRows, id);
  }

  async setCostPlanExport(devId, wbsProjectBudget): Promise<void> {
    await CostPlanService.setCostPlanExport(devId, wbsProjectBudget);
  }

  @action
  async setWbsSelected(file, data, customProperties) {
    this.lastWbsSelected = this.wbsSelected;
    this.wbsSelected = false;
    let costPlan = await CostPlanService.addCostPlan(
      file,
      data,
      customProperties
    );
    if (costPlan) {
      this.wbsSelected = new FirebaseDocument<CostPlan>(
        costPlan.ref.id,
        costPlan.data
      );
      await CostPlanService.fetchCostPlans();
    }

    WBSStore.loading = false;
  }
  @action
  handleCancel() {
    if (this.wbsSelected)
      CostPlanService.DeleteCostPlan(
        this.wbsSelected.id,
        this.wbsSelected.data.fileName
      );
    this.wbsSelected = this.lastWbsSelected;
    this.lastWbsSelected = null;
    this.resetStore();
  }
  @action
  handleTryAgain() {
    if (this.wbsSelected) {
      CostPlanService.UpdateCostPlan(this.wbsSelected.id, {
        progress: 0,
        status: "pending",
      });
    }
  }

  @action
  async handleButtonNewSheet() {
    if ((CostPlanStore.buttonNewSheet = false)) {
      CostPlanStore.buttonNewSheet = true;
    } else {
      CostPlanStore.buttonNewSheet = false;
    }
  }

  @action
  async deleteWbsByDev(dev: string) {
    await CostPlanService.DeleteCostPlanByDev(
      DevelopmentStore.deleteDevelopment
    );
  }

  @action
  async addCostPlanExport() {
    await CostPlanService.addCostPlanExport();
  }

  @action
  async setFileImportConfig(data, userId) {
    await CostPlanService.setFileImportConfig(data, userId);
  }

  @action
  async currentCostPlanExport(id: string) {
    this.currentCostPlan = id;
    WBSStore.changeCurrentWbsTotalCost();
  }

  async duplicateCostPlan(id: string, nameWbs: string, descriptionWbs: string) {
    await axios.post(`${process.env.REACT_APP_COPY_WBS}`, {
      id: id,
      nameWbs: nameWbs,
      descriptionWbs: descriptionWbs,
    });
  }
}

let CostPlanStore = new Store();

export { CostPlanStore };



// WEBPACK FOOTER //
// ./src/modules/costPlan/CostPlanStore.ts